'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('OnboardingMoodCtrl', OnboardingMoodCtrl);

  OnboardingMoodCtrl.$inject = ['$rootScope', '$state', '$q', '$timeout', '$stateParams', 'moodTrackers', 'moodTrackerSvc', 'onboardingRouter', 'MetadataSvc', 'moodTrackerDataMappingSvc', 'loadingScreenSvc', 'NotifyingSvc'];

  function OnboardingMoodCtrl($rootScope, $state, $q, $timeout, $stateParams, moodTrackers, moodTrackerSvc, onboardingRouter, MetadataSvc, moodTrackerDataMappingSvc, loadingScreenSvc, NotifyingSvc) {
    $rootScope.$state = $state;
    var vm = this;
    vm.$onInit = activate;

    vm.onboardingMoodTrackers = moodTrackers;
    vm.doneWithCheckin = saveMoodCheckin;
    vm.skipCheckin = _navigate;
    vm.context = onboardingRouter.getContext();

    /////////////////

    var saveMoodsReq = void 0;
    var updateProfileReq = void 0;

    function saveMoodCheckin(moods) {
      saveMoodsReq = moodTrackerSvc.saveMoods(moodTrackerDataMappingSvc.mapMoodsForSaving(moods), vm.messageId, vm.trackerNote);
      //TODO - remove in favor of API eval
      if (moodTrackerSvc.hasLowMood(moods)) {
        updateProfileReq = MetadataSvc.updateProfileComponents({
          'mood:low_mood': true
        });
      }

      $q.all([saveMoodsReq, updateProfileReq]).then(function () {
        return _navigate();
      });
    }

    function _navigate() {
      onboardingRouter.goToNextStep($stateParams, {
        name: 'onboarding.mood.overlay'
      });
    }

    function activate() {
      vm.trackerValues = [];
      vm.trackerNote = '';
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.GET_AGREEMENTS, true);
      $timeout(function () {
        loadingScreenSvc.removeLoadingScreen();
      }, 1000);
    }
  }
})();